var _style, _circle, _path, _path2, _path3, _path4, _path5, _g, _g2, _polygon, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x35_4eb4525-c955-4dae-93ec-ba88c02e09fe-29b43a1ab02945b1aeea7452066f0bca-b526e7bf42c14ca8bcbd0364fc5118ef",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 366 426.1",
    style: {
      enableBackground: "new 0 0 366 426.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {\n      opacity: 0.4;\n      fill: #FFFFFF;\n      enable-background: new;\n    }\n\n    .st1 {\n      fill: #303030;\n      enable-background: new;\n    }\n\n    .st2 {\n      opacity: 0.4;\n      fill: #303030;\n      enable-background: new;\n    }\n\n    .st3 {\n      fill: #303030;\n    }\n\n    .st4 {\n      opacity: 0.4;\n      fill: url(#SVGID_1_-aea76ee47ca34e5986569b8bcd7eb757);\n      enable-background: new;\n    }\n  ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "503 Accounts down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 185,
    cy: 224.9,
    r: 170.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,208.8c0.4,0.5,0.4,1.2-0.1,1.7c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.7-0.1-0.9-0.4c-0.9-1-1.8-1-3.4-1 s-3.6,0.1-5.2-1.8s-1.4-3.8-1.2-5.4s0.3-2.5-0.6-3.5s-1.8-1-3.4-1s-3.6,0.1-5.2-1.8c-0.4-0.5-0.4-1.3,0.1-1.7 c0.5-0.4,1.3-0.4,1.7,0.1c0.9,1,1.8,1,3.4,1s3.6-0.1,5.2,1.8s1.4,3.8,1.2,5.4S68,205,68.9,206s1.8,1,3.4,1 C74.2,206.7,76.2,207.4,77.5,208.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.6,96.9c-0.5-0.4-0.5-1.2-0.1-1.7s1.2-0.5,1.7-0.1l0,0l0,0l4.2,3.9l3.9-4.2c0.4-0.5,1.2-0.5,1.7-0.1 c0.5,0.4,0.5,1.2,0.1,1.7l-3.9,4.2l4.2,3.9c0.5,0.5,0.5,1.2,0.1,1.7c-0.2,0.3-0.6,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.8-0.3l-4.2-3.9 l-3.9,4.2c-0.2,0.3-0.6,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.8-0.3c-0.5-0.5-0.5-1.2-0.1-1.7l3.9-4.2L333.6,96.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.4,254.6l-3.1-3.8l-3.8,3.1c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.7-0.2-0.9-0.4c-0.4-0.5-0.3-1.3,0.2-1.7 l3.8-3.1l-3.1-3.8c-0.4-0.5-0.3-1.3,0.2-1.7c0.5-0.4,1.3-0.3,1.7,0.2l3.1,3.8l3.8-3.1c0.5-0.4,1.3-0.3,1.7,0.2 c0.4,0.5,0.3,1.3-0.2,1.7l-3.8,3.1l3.1,3.8c0.4,0.5,0.3,1.3-0.2,1.7c-0.2,0.2-0.5,0.3-0.8,0.3C289,255,288.7,254.8,288.4,254.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,121c0.1-0.6,0.7-1.1,1.3-1.1l5.7,0.5l0.5-5.7c0.1-0.7,0.6-1.2,1.3-1.1c0.7,0.1,1.2,0.6,1.1,1.3l0,0l0,0 l-0.5,5.7l5.7,0.5c0.7,0.1,1.1,0.6,1.1,1.3c-0.1,0.6-0.6,1.1-1.2,1.1h-0.1L9.2,123l-0.5,5.7c-0.1,0.6-0.6,1.1-1.2,1.1H7.4 c-0.7-0.1-1.1-0.6-1.1-1.3l0.5-5.7l-5.7-0.5c-0.6,0-1.1-0.5-1.1-1.1C0,121.1,0,121.1,0,121z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.5,406.2c0.4,0.5,0.4,1.2-0.1,1.7l-3.5,3l3,3.5c0.4,0.5,0.4,1.2-0.1,1.7c-0.2,0.2-0.5,0.3-0.8,0.3 c-0.3,0-0.7-0.1-0.9-0.4l-3-3.5l-3.5,3c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.7-0.1-0.9-0.4c-0.4-0.5-0.4-1.2,0.1-1.7l3.5-3l-3-3.5 c-0.4-0.5-0.4-1.3,0.1-1.7c0.5-0.4,1.3-0.4,1.7,0.1l0,0l0,0l3,3.5l3.5-3C281.3,405.7,282.1,405.7,282.5,406.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 215.6,
    cy: 125.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 218.9,
    cy: 128.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 222.2,
    cy: 131.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 225.5,
    cy: 135,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 216.3,
    cy: 121.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 219.6,
    cy: 124.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 223,
    cy: 128,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 226.3,
    cy: 131.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M217.9,118.5c0.5-0.4,0.5-1.1,0.1-1.6l-0.1-0.1c-0.3-0.3-0.7-0.4-1.1-0.3c-0.2,0.6-0.5,1.2-0.7,1.9l0.1,0.1 C216.7,118.9,217.4,118.9,217.9,118.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 220.3,
    cy: 120.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 223.7,
    cy: 124.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 227,
    cy: 127.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 230.3,
    cy: 130.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218.6,114.7c0.5-0.4,0.5-1.1,0.1-1.6l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c-0.3,0.7-0.5,1.4-0.9,2.2 C217.8,115.1,218.3,115,218.6,114.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 221.1,
    cy: 117.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 224.4,
    cy: 120.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 227.7,
    cy: 123.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 231,
    cy: 126.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.3,110.9c0.4-0.4,0.4-0.9,0.2-1.4c-0.2,0.4-0.4,1-0.7,1.7C219,111.1,219.2,111.1,219.3,110.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 221.8,
    cy: 113.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 225.1,
    cy: 116.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 228.4,
    cy: 119.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 231.8,
    cy: 123.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 235.1,
    cy: 126.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.2,107.5c0.3,0,0.7-0.1,0.9-0.4c0.5-0.4,0.5-1.1,0.1-1.6l-0.1-0.1c-0.4-0.4-0.9-0.4-1.4-0.2 C218.7,106,218.9,106.8,219.2,107.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 222.6,
    cy: 109.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 225.8,
    cy: 112.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 229.2,
    cy: 116.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 232.5,
    cy: 119.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 235.9,
    cy: 122.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.1,103.4c0.5,0.5,1.2,0.5,1.7,0s0.5-1.2,0-1.7c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0.5-0.8,1-1,1.7 C218.9,103.2,219,103.3,219.1,103.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 223.2,
    cy: 105.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 226.6,
    cy: 109.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 229.9,
    cy: 112.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.2,
    cy: 115.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 236.6,
    cy: 118.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 240,
    cy: 122.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 224,
    cy: 102,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 227.3,
    cy: 105.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 230.7,
    cy: 108.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.9,
    cy: 111.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 237.3,
    cy: 115.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 240.6,
    cy: 118.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.8,99.1c0.5,0.5,1.2,0.5,1.7,0s0.5-1.2,0-1.7c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4,0.4-0.8,0.7-1.2,1.1 C223.5,98.5,223.6,98.8,223.8,99.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 228,
    cy: 101.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 231.4,
    cy: 104.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 234.8,
    cy: 108.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 238,
    cy: 111.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 241.3,
    cy: 114.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 244.7,
    cy: 117.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 228.7,
    cy: 97.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 232.1,
    cy: 101,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 235.4,
    cy: 104.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 238.8,
    cy: 107.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 242,
    cy: 110.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 245.4,
    cy: 114.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228.6,94.8c0.4,0.5,1.1,0.5,1.6,0.1l0.1-0.1c0.2-0.2,0.3-0.5,0.3-0.8l-1.9-0.8l-0.4,0.4 C228.2,94,228.3,94.5,228.6,94.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 232.8,
    cy: 97.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 236.1,
    cy: 100.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 239.4,
    cy: 103.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 242.8,
    cy: 107,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 246.1,
    cy: 110.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 228.9,
    cy: 138.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 232.3,
    cy: 141.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 235.6,
    cy: 144.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 239,
    cy: 148.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 242.2,
    cy: 151.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 229.8,
    cy: 134.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233,
    cy: 137.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 236.3,
    cy: 141.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 239.6,
    cy: 144.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 243,
    cy: 147.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245.4,150.1c-0.4,0.4-0.4,0.9-0.2,1.4l1.2-1.7C246.1,149.7,245.7,149.8,245.4,150.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.7,
    cy: 134,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 237,
    cy: 137.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 240.4,
    cy: 140.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 243.7,
    cy: 143.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.9,146.3c-0.5-0.5-1.2-0.5-1.7,0s-0.5,1.2,0,1.7l0,0l0,0c0.4,0.3,0.8,0.4,1.3,0.3l0.7-1 C248.2,146.9,248.1,146.6,247.9,146.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 234.5,
    cy: 130.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 237.8,
    cy: 133.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 241.1,
    cy: 136.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 244.4,
    cy: 140.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 247.7,
    cy: 143.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 238.5,
    cy: 129.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 241.8,
    cy: 133,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 245.1,
    cy: 136.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 248.5,
    cy: 139.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.9,142c-0.4,0.4-0.4,1-0.1,1.5l1.2-1.8C251.6,141.6,251.2,141.7,250.9,142z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 239.2,
    cy: 126,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 242.6,
    cy: 129.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 245.9,
    cy: 132.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 249.2,
    cy: 135.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 252.5,
    cy: 139.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 243.3,
    cy: 125.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 246.7,
    cy: 128.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 249.9,
    cy: 132,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 253.2,
    cy: 135.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.7,137.7l-0.1,0.1L255.7,137.7C255.8,137.7,255.8,137.7,255.7,137.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 244,
    cy: 121.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 247.3,
    cy: 125,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 250.6,
    cy: 128.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 254,
    cy: 131.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M258.1,133.9c-0.5-0.5-1.2-0.5-1.7,0c-0.5,0.5-0.5,1.2,0,1.7c0.3,0.3,0.7,0.4,1.1,0.3l0.9-1 C258.5,134.5,258.4,134.2,258.1,133.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 248,
    cy: 121.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 251.4,
    cy: 124.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 254.8,
    cy: 127.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7014 -0.7128 0.7128 0.7014 -16.3506 223.0222)",
    className: "st3",
    cx: 258,
    cy: 131,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 248.7,
    cy: 117.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 252.1,
    cy: 120.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 255.5,
    cy: 124,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7014 -0.7128 0.7128 0.7014 -13.4482 222.3841)",
    className: "st3",
    cx: 258.7,
    cy: 127.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261.2,129.7c-0.5,0.4-0.5,1.1-0.1,1.6l0.1,0.1c0.2,0.1,0.3,0.2,0.5,0.3l1.5-1.5c-0.1-0.2-0.1-0.4-0.3-0.5 C262.5,129.2,261.8,129.2,261.2,129.7L261.2,129.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 249.5,
    cy: 113.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 252.8,
    cy: 116.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8064 -0.5913 0.5913 0.8064 -21.5028 174.735)",
    className: "st3",
    cx: 256.1,
    cy: 120.2,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7013 -0.7129 0.7129 0.7013 -10.4728 221.8787)",
    className: "st3",
    cx: 259.5,
    cy: 123.4,
    rx: 1.2,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261.9,125.9c-0.5,0.5-0.5,1.2,0,1.7c0.5,0.5,1.2,0.5,1.7,0c0.4-0.3,0.4-0.9,0.2-1.3l-0.6-0.6 C262.8,125.5,262.3,125.5,261.9,125.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.9,164.5c0.5-0.4,0.5-1.1,0.1-1.6l-0.1-0.1c-0.3-0.3-0.7-0.4-1.1-0.3c-0.3,0.6-0.5,1.3-0.7,1.9l0.1,0.1 C198.7,164.9,199.4,164.9,199.9,164.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.7,160.7c0.5-0.4,0.5-1.1,0.1-1.6l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c-0.3,0.8-0.6,1.5-0.9,2.2 C199.9,161.1,200.4,161,200.7,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.6,155.5c-0.2,0.6-0.4,1.1-0.6,1.7c0.2-0.1,0.3-0.1,0.4-0.3C201.8,156.5,201.9,156,201.6,155.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 203.9,
    cy: 159.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 204.6,
    cy: 155.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 205.3,
    cy: 151.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 206,
    cy: 148,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 209.4,
    cy: 151.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.6,145.1c0.5-0.4,0.5-1.1,0.1-1.6l-0.1-0.1c-0.3-0.3-0.8-0.4-1.2-0.3c-0.2,0.6-0.5,1.2-0.7,1.8 c0,0.1,0.1,0.2,0.2,0.2C206.4,145.5,207.1,145.5,207.6,145.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 210.1,
    cy: 147.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208.3,141.3c0.5-0.4,0.5-1.1,0.1-1.6l-0.1-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.3,0.7-0.6,1.5-0.9,2.2 C207.5,141.7,208,141.6,208.3,141.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 210.8,
    cy: 143.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 214.1,
    cy: 147,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M209.1,137.5c0.4-0.4,0.4-1,0.1-1.5c-0.2,0.6-0.5,1.2-0.7,1.8C208.8,137.8,209,137.7,209.1,137.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 211.5,
    cy: 139.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 214.8,
    cy: 143.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 212.3,
    cy: 136.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 215.6,
    cy: 139.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 218.9,
    cy: 142.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 213,
    cy: 132.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 216.4,
    cy: 135.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 219.6,
    cy: 138.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 213.7,
    cy: 128.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 217.1,
    cy: 131.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 220.4,
    cy: 135.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 223.7,
    cy: 138.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.9,176.2c0.3-0.3,0.3-0.8,0.1-1.2c-0.1,0.2-0.2,0.5-0.3,0.7C193.6,175.7,193.7,175.9,193.9,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M197.1,177.9c-0.4-0.5-1.1-0.5-1.6-0.1l-0.1,0.1c0.5,0.5,1,1.1,1.6,1.7h0.1 C197.6,179.1,197.6,178.4,197.1,177.9C197.1,177.9,197.1,177.9,197.1,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.4,181.2c-0.4-0.5-1.1-0.5-1.6-0.1l-0.1,0.1c0,0.1,0,0.1-0.1,0.1h0l0,0c0.5,0.5,1.1,1.1,1.6,1.7l0.1-0.1 c0.5-0.3,0.6-1,0.3-1.5C200.5,181.3,200.5,181.3,200.4,181.2L200.4,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M203.7,184.5c-0.4-0.5-1.1-0.5-1.6-0.1l-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2l1.6,1.6c0.1,0,0.1-0.1,0.2-0.1 C204.2,185.8,204.2,185.1,203.7,184.5L203.7,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.1,187.7c-0.4-0.5-1.1-0.5-1.6-0.1l-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.2l1.6,1.6c0.1,0,0.1-0.1,0.2-0.1 C207.5,188.9,207.5,188.2,207.1,187.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.4,191c-0.4-0.5-1.1-0.5-1.6-0.1l-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0.6,0.6,1.1,1.1,1.7,1.6 c0.1,0,0.1-0.1,0.2-0.1C210.9,192.2,210.9,191.5,210.4,191z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.7,194.3c-0.4-0.5-1.1-0.5-1.6-0.1l-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0.8,0.7,1.3,1.3,1.7,1.6l0.1-0.1 C214.2,195.6,214.2,194.9,213.7,194.3L213.7,194.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 197,
    cy: 175,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 200.3,
    cy: 178.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 203.6,
    cy: 181.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 206.9,
    cy: 184.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 210.3,
    cy: 188.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 213.6,
    cy: 191.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 197.7,
    cy: 171.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 201,
    cy: 174.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 204.4,
    cy: 177.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 207.7,
    cy: 181,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 211,
    cy: 184.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 214.3,
    cy: 187.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.8,190c-0.5,0.4-0.5,1.1-0.1,1.6l0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1l1.3-1.9 C217.9,189.6,217.2,189.6,216.8,190z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 198.4,
    cy: 167.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 201.7,
    cy: 170.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 205.1,
    cy: 174,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 208.4,
    cy: 177.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 211.7,
    cy: 180.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 215,
    cy: 183.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 218.4,
    cy: 187.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 202.5,
    cy: 166.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 205.8,
    cy: 170.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 209.1,
    cy: 173.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 212.5,
    cy: 176.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 215.8,
    cy: 180,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 219.1,
    cy: 183.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 203.2,
    cy: 163.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 206.5,
    cy: 166.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 209.8,
    cy: 169.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 213.2,
    cy: 173,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 216.6,
    cy: 176.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 219.8,
    cy: 179.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222.3,182c-0.5,0.4-0.5,1.1-0.1,1.6l0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.2l1.3-1.9c-0.3-0.4-1-0.5-1.4-0.2 C222.4,181.9,222.4,181.9,222.3,182z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 207.3,
    cy: 162.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 210.6,
    cy: 165.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 213.9,
    cy: 169.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 217.2,
    cy: 172.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 220.6,
    cy: 175.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 223.9,
    cy: 179,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 208,
    cy: 158.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 211.3,
    cy: 162.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 214.6,
    cy: 165.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 217.9,
    cy: 168.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 221.3,
    cy: 172,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 224.6,
    cy: 175.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 208.7,
    cy: 155.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 212.1,
    cy: 158.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 215.4,
    cy: 161.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 218.7,
    cy: 164.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 222,
    cy: 168.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 225.3,
    cy: 171.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M229.5,173.9c-0.5-0.5-1.2-0.5-1.7,0s-0.5,1.2,0,1.7c0.1,0.1,0.3,0.2,0.4,0.3L229.5,173.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 212.7,
    cy: 154.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 216.1,
    cy: 157.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 219.4,
    cy: 161.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 222.7,
    cy: 164.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 226,
    cy: 167.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 229.4,
    cy: 171,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 213.5,
    cy: 150.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 216.8,
    cy: 154.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 220.1,
    cy: 157.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 223.4,
    cy: 160.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 226.8,
    cy: 163.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 230.1,
    cy: 167.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 217.5,
    cy: 150.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 220.8,
    cy: 153.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 224.2,
    cy: 156.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 227.5,
    cy: 160.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 230.8,
    cy: 163.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M235,165.8c-0.5-0.5-1.2-0.5-1.7,0s-0.5,1.2,0,1.7c0.2,0.1,0.3,0.2,0.5,0.3l1.3-1.8 C235.1,165.9,235,165.9,235,165.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 218.2,
    cy: 146.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 221.6,
    cy: 149.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 224.9,
    cy: 153.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 228.3,
    cy: 156.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 231.5,
    cy: 159.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 234.9,
    cy: 162.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 222.3,
    cy: 146,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 225.6,
    cy: 149.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 229,
    cy: 152.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 232.4,
    cy: 155.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 235.6,
    cy: 159.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M237.8,162.2l0.5-0.8c-0.1,0-0.2,0.1-0.2,0.2C237.9,161.7,237.8,162,237.8,162.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 223.1,
    cy: 142.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 226.3,
    cy: 145.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 229.7,
    cy: 148.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233,
    cy: 152.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 236.4,
    cy: 155.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.5,157.8c-0.5-0.5-1.2-0.5-1.7,0s-0.5,1.2,0,1.7l0,0c0.2,0.2,0.4,0.3,0.6,0.3l1.2-1.8 C240.6,157.9,240.6,157.8,240.5,157.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 227.1,
    cy: 141.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 230.4,
    cy: 145,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.7,
    cy: 148.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 237.1,
    cy: 151.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 240.3,
    cy: 154.8,
    r: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "186.1,179.5 185.6,180 187.7,180 187.1,179.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "184,181.5 183.5,182 189.8,182.1 189.3,181.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "181.9,183.6 181.4,184.1 189.8,184.1 190.3,183.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "179.9,185.6 179.4,186.1 187.8,186.2 188.2,185.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "177.8,187.7 177.3,188.2 185.7,188.3 186.2,187.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "175.7,189.8 175.2,190.2 183.6,190.3 184.1,189.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "173.6,191.8 173.1,192.3 181.6,192.4 182.1,191.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "171.5,193.9 171,194.4 179.5,194.4 180,193.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "169.5,195.9 169,196.4 177.5,196.5 178,196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "167.4,198 166.9,198.5 175.4,198.5 175.9,198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "165.3,200 164.8,200.5 173.4,200.6 173.9,200.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "163.2,202.1 162.7,202.6 171.3,202.6 171.8,202.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "161.2,204.1 160.7,204.6 169.3,204.7 169.8,204.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "159.1,206.2 158.6,206.7 167.2,206.8 167.7,206.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "157,208.2 156.5,208.7 165.2,208.8 165.7,208.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "154.9,210.3 154.4,210.8 163.1,210.9 163.6,210.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "152.8,212.4 152.3,212.9 161.1,212.9 161.6,212.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "150.8,214.4 150.3,214.9 159,215 159.5,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "148.7,216.5 148.2,217 157,217 157.5,216.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "146.6,218.5 146.1,219 154.9,219.1 155.4,218.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "144.5,220.6 144,221.1 152.9,221.1 153.4,220.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "142.5,222.6 142,223.1 150.8,223.2 151.3,222.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "140.4,224.7 139.9,225.2 148.8,225.3 149.3,224.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "138.3,226.7 137.8,227.2 146.7,227.3 147.2,226.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "136.2,228.8 135.7,229.3 144.7,229.4 145.2,228.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "134.1,230.9 133.6,231.4 142.6,231.4 143.1,230.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "132.1,232.9 131.6,233.4 140.6,233.5 141.1,233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "130,235 129.5,235.5 138.5,235.5 139,235  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "127.9,237 127.4,237.5 136.5,237.6 137,237.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "125.8,239.1 125.3,239.6 134.4,239.6 134.9,239.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "123.8,241.1 123.3,241.6 132.4,241.7 132.9,241.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "121.7,243.2 121.2,243.7 130.3,243.8 130.8,243.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "119.6,245.2 119.1,245.7 128.3,245.8 128.8,245.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "117.5,247.3 117,247.8 126.2,247.9 126.7,247.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "115.4,249.4 114.9,249.8 124.2,249.9 124.7,249.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "113.4,251.4 112.9,251.9 122.1,252 122.6,251.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.3,253.5 110.8,254 120.1,254 120.6,253.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "109.2,255.5 108.7,256 118,256.1 118.5,255.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "107.1,257.6 106.6,258.1 115.9,258.2 116.4,257.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "105,259.7 104.5,260.2 113.9,260.2 114.4,259.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "102.9,261.7 102.4,262.2 111.8,262.3 112.3,261.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "100.8,263.8 100.3,264.3 109.7,264.4 110.2,263.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "98.7,265.9 98.2,266.4 107.7,266.4 108.2,265.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "96.7,267.9 96.2,268.4 105.6,268.5 106.1,268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "94.6,270 94.1,270.5 103.6,270.5 104.1,270  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "92.5,272 92,272.5 101.5,272.6 102,272.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "90.4,274.1 89.9,274.6 99.5,274.7 100,274.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "88.4,276.1 87.9,276.6 97.4,276.7 97.9,276.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "86.3,278.2 85.8,278.7 95.4,278.8 95.9,278.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "84.2,280.3 83.7,280.7 93.3,280.8 93.8,280.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.1,282.3 81.6,282.8 91.3,282.9 91.8,282.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "81.4,284.4 82.4,284.9 89.2,284.9 89.7,284.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "85.8,286.5 86.9,287 87.2,287 87.7,286.5  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_-aea76ee47ca34e5986569b8bcd7eb757",
    gradientUnits: "userSpaceOnUse",
    x1: 278.596,
    y1: 659.7865,
    x2: 337.088,
    y2: 724.7488,
    gradientTransform: "matrix(1 0 0 -1 2.000000e-02 796.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "257.3,0 241.4,95.9 310.8,165.8 416.5,144.1 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.4,248.7c4.5,0,8.2-3.6,8.2-8.1c0-4.5-3.6-8.2-8.1-8.2c-4.5,0-8.2,3.6-8.2,8.1c0,2.2,0.8,4.3,2.4,5.8 C167.2,247.9,169.3,248.7,171.4,248.7z M166.7,235.8c2.6-2.6,6.8-2.6,9.4,0c2.6,2.6,2.6,6.8,0,9.4s-6.8,2.6-9.4,0c0,0,0,0,0,0l0,0 c-2.6-2.5-2.6-6.7-0.1-9.3L166.7,235.8z M146.7,270.3c1.3,0,2.6-0.5,3.5-1.5l15.1-15.1c7.3,3.4,16,0.2,19.3-7.1s0.2-16-7.1-19.3 c-5.5-2.6-12.1-1.4-16.4,2.9l0,0c-4.4,4.3-5.5,10.9-2.9,16.5L143,261.9c-1.9,2-1.8,5.2,0.3,7.1C144.2,269.8,145.4,270.3,146.7,270.3 L146.7,270.3z M163.6,232.7c2.1-2.1,4.9-3.2,7.8-3.2c2.9,0,5.7,1.2,7.8,3.2c2.1,2.1,3.2,4.9,3.2,7.8c0,2.9-1.2,5.7-3.2,7.8 c-4.4,4.3-11.3,4.3-15.7,0C159.2,244,159.3,237,163.6,232.7C163.6,232.7,163.6,232.7,163.6,232.7L163.6,232.7L163.6,232.7z  M145.6,264.2l14.4-14.4c0.3,0.4,0.6,0.8,1,1.1c0.4,0.4,0.8,0.7,1.1,1l-14.5,14.5c-0.6,0.6-1.5,0.6-2.1,0l0,0l-0.1,0 C145,265.7,145.1,264.8,145.6,264.2L145.6,264.2z M317.6,180.5c0.5,0.5,0.5,1.3,0,1.8c0,0,0,0,0,0l0,0c-0.2,0.2-0.6,0.4-0.9,0.4 c-0.3,0-0.7-0.1-0.9-0.4l-13.7-13.7c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0L317.6,180.5z M299.8,162.7c0.5,0.5,0.5,1.3,0,1.8 c0,0,0,0,0,0l0,0c-0.2,0.2-0.6,0.4-0.9,0.4c-0.3,0-0.7-0.1-0.9-0.4l-3.1-3.1c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0 L299.8,162.7z M324.3,176.7l-90.4-90.4c-1.2-1.3-2.9-1.9-4.7-1.9c-1.8,0-3.4,0.7-4.7,1.9l-7.5,7.5c-1.3,1.2-1.9,2.9-1.9,4.7 c0,1.5,0.5,2.9,1.4,4.1l-27.8,68.8c-2.2-0.5-4.5,0.2-6.1,1.8L31.7,323.8c-2.6,2.6-2.6,6.8,0,9.4l0,0l4.8,4.8l-1.6,1.6 c-2.3,2.3-2.3,5.9,0,8.2c0,0,0,0,0,0l0,0l5.1,5.1c-1.9,2.1-2.8,5-2.2,7.8C39,367,44,372,50.3,373.2c0.6,0.1,1.1,0.1,1.7,0.1 c2.3,0.1,4.4-0.8,6.1-2.3l4.9,4.9c2.3,2.3,5.9,2.3,8.2,0c0,0,0,0,0,0l0,0l1.6-1.6l4.8,4.8c1.2,1.3,2.9,1.9,4.7,1.9 c1.8,0,3.4-0.7,4.7-1.9l150.6-150.6c1.3-1.2,1.9-2.9,1.9-4.7c0-0.6-0.1-1.1-0.2-1.7l68.8-27.8c1.1,0.7,2.3,1,3.6,1 c1.8,0,3.4-0.7,4.7-1.9l7.5-7.5c1.3-1.2,1.9-2.9,1.9-4.7C326.1,179.5,325.6,177.8,324.3,176.7L324.3,176.7z M133.8,328l-1.3,1.3 h-3.9V324h5.2V328z M130.9,330.8l-2.4,2.4v-2.4H130.9z M127,329.3h-5.2V324h5.2L127,329.3z M127,330.8v3.9l-1.3,1.3h-3.9v-5.2 L127,330.8L127,330.8z M124.2,337.5l-2.4,2.4v-2.4H124.2z M120.3,322.5H115v-5.2h5.2v5.2H120.3z M120.3,324v5.2H115V324H120.3z  M120.3,330.8v5.2H115v-5.2H120.3z M120.3,337.5v3.9l-1.3,1.3h-4v-5.2L120.3,337.5L120.3,337.5z M117.5,344.3l-2.4,2.4v-2.4H117.5z  M113.5,315.8h-5.2v-5.2h5.2V315.8z M113.5,317.3v5.2h-5.2v-5.2H113.5z M113.5,324v5.2h-5.2V324H113.5z M113.5,330.8v5.2h-5.2v-5.2 H113.5z M113.5,337.5v5.2h-5.2v-5.2H113.5z M113.5,344.3v3.9l-1.3,1.3h-3.9v-5.2L113.5,344.3L113.5,344.3z M110.7,351l-2.4,2.4V351 H110.7z M106.8,315.8h-5.2v-5.2h5.2V315.8z M106.8,317.3v5.2h-5.2v-5.2H106.8z M106.8,324v5.2h-5.2V324H106.8z M106.8,330.8v5.2 h-5.2v-5.2H106.8z M106.8,337.5v5.2h-5.2v-5.2H106.8z M106.8,344.3v5.2h-5.2v-5.2H106.8z M106.8,351v3.9l-1.3,1.3h-3.9V351H106.8z  M104,357.7l-2.4,2.4v-2.4H104z M100.1,309.1h-5.2v-5.2h5.2V309.1z M100.1,310.6v5.2h-5.2v-5.2H100.1z M100.1,317.3v5.2h-5.2v-5.2 H100.1z M100.1,324v5.2h-5.2V324L100.1,324z M100.1,330.8v5.2h-5.2v-5.2L100.1,330.8z M100.1,337.5v5.2h-5.2v-5.2H100.1z  M100.1,344.3v5.2h-5.2v-5.2H100.1z M100.1,351v5.2h-5.2V351L100.1,351z M100.1,357.7v3.9l-1.3,1.3h-3.9v-5.2L100.1,357.7 L100.1,357.7z M97.3,364.5l-2.4,2.4v-2.4H97.3z M93.3,302.3h-5.2v-5.2h5.2V302.3z M93.3,303.8v5.2h-5.2v-5.2L93.3,303.8z  M93.3,310.6v5.2h-5.2v-5.2H93.3z M93.3,317.3v5.2h-5.2v-5.2H93.3z M93.3,324v5.2h-5.2V324L93.3,324z M93.3,330.8v5.2h-5.2v-5.2 L93.3,330.8z M93.3,337.5v5.2h-5.2v-5.2H93.3z M93.3,344.3v5.2h-5.2v-5.2H93.3z M93.3,351v5.2h-5.2V351L93.3,351z M93.3,357.7v5.2 h-5.2v-5.2H93.3z M93.3,364.5v3.9l-1.3,1.3h-3.9v-5.2L93.3,364.5L93.3,364.5z M90.5,371.2l-2.4,2.4v-2.4H90.5z M86.6,302.3h-5.2 v-5.2h5.2V302.3z M86.6,303.8v5.2h-5.2v-5.2L86.6,303.8z M86.6,310.6v5.2h-5.2v-5.2H86.6z M86.6,317.3v5.2h-5.2v-5.2H86.6z  M86.6,324v5.2h-5.2V324L86.6,324z M86.6,330.8v5.2h-5.2v-5.2L86.6,330.8z M86.6,337.5v5.2h-5.2v-5.2H86.6z M86.6,344.3v5.2h-5.2 v-5.2H86.6z M86.6,351v5.2h-5.2V351L86.6,351z M86.6,357.7v5.2h-5.2v-5.2H86.6z M86.6,364.5v5.2h-5.2v-5.2H86.6z M86.6,371.2v3.9 l-1.3,1.3h-3.9v-5.2L86.6,371.2L86.6,371.2z M79.9,303.8v5.2h-5.2v-5.2L79.9,303.8z M74.6,302.3v-5.2h5.2v5.2H74.6z M79.9,310.6v5.2 h-5.2v-5.2H79.9z M79.9,317.3v5.2h-5.2v-5.2H79.9z M79.9,324v5.2h-5.2V324L79.9,324z M79.9,330.8v5.2h-5.2v-5.2L79.9,330.8z  M79.9,337.5v5.2h-5.2v-5.2H79.9z M79.9,344.3v5.2h-5.2v-5.2H79.9z M79.9,351v5.2h-5.2V351L79.9,351z M79.9,357.7v5.2h-5.2v-5.2 H79.9z M79.9,364.5v5.2h-5.2v-5.2H79.9z M79.9,295.6h-5.2v-5.2h5.2V295.6z M34.2,326.3l2.3-2.3h3v5.2h-5.2L34.2,326.3L34.2,326.3z  M43.2,317.3h3v5.2H41v-3L43.2,317.3z M49.9,310.6h3v5.2h-5.2v-3L49.9,310.6z M56.7,303.8h3v5.2h-5.2v-3L56.7,303.8z M63.4,297.1h3 v5.2h-5.2v-3L63.4,297.1z M70.2,290.4h3v5.2H68v-3L70.2,290.4z M67.9,356.2V351h5.2v5.2L67.9,356.2z M73.1,357.7v5.2h-5.2v-5.2H73.1 z M67.9,349.5v-5.2h5.2v5.2H67.9z M67.9,342.8v-5.2h5.2v5.2H67.9z M67.9,336v-5.2h5.2v5.2L67.9,336z M67.9,329.3V324h5.2v5.2h-5.2 V329.3z M67.9,322.5v-5.2h5.2v5.2H67.9z M67.9,315.8v-5.2h5.2v5.2H67.9z M67.9,309.1v-5.2h5.2v5.2H67.9z M67.9,302.3v-5.2h5.2v5.2 H67.9z M66.4,310.6v5.2h-5.2v-5.2H66.4z M61.2,309.1v-5.2h5.2v5.2H61.2z M66.4,317.3v5.2h-5.2v-5.2H66.4z M66.4,324v5.2h-5.2V324 L66.4,324z M66.4,330.8v5.2h-5.2v-5.2L66.4,330.8z M66.4,337.5v5.2h-5.2v-5.2H66.4z M66.4,344.3v5.2h-5.2v-5.2H66.4z M66.4,351v5.2 h-5.2V351L66.4,351z M64.9,295.6l1.5-1.5v1.5H64.9z M59.7,317.3v5.2h-5.2v-5.2H59.7z M54.4,315.8v-5.2h5.2v5.2H54.4z M59.7,324v5.2 h-5.2V324L59.7,324z M59.7,330.8v5.2h-5.2v-5.2L59.7,330.8z M59.7,337.5v5.2h-5.2v-5.2H59.7z M59.7,344.3v5.2h-5.2v-5.2H59.7z  M58.2,302.3l1.5-1.5v1.5H58.2z M52.9,324v5.2h-5.2V324H52.9z M47.7,322.5v-5.2h5.2v5.2H47.7z M52.9,330.8v5.2h-5.2v-5.2H52.9z  M52.9,337.5v5.2h-5.2v-5.2H52.9z M51.4,309.1l1.5-1.5v1.5H51.4z M46.2,330.8v5.2H41v-5.2L46.2,330.8z M40.9,329.3V324h5.2v5.2h-5.2 V329.3z M44.7,315.8l1.5-1.5v1.5H44.7z M38,322.5l1.5-1.5v1.5H38z M40.9,337.5h5.2v5.2l0,0L40.9,337.5z M47.7,344.3h5.2v5.2l0,0 L47.7,344.3z M54.4,351h5.2v5.2l0,0L54.4,351z M61.2,357.7h5.2v5.2l0,0L61.2,357.7z M67.9,364.5h5.2v5.2l0,0L67.9,364.5z  M71.7,288.9l1.5-1.5v1.5H71.7z M34.2,330.8h5.2v5.2l0,0L34.2,330.8z M51,370c-2.4-0.4-4.6-1.6-6.3-3.4c-1.7-1.7-2.9-3.9-3.4-6.3 c-0.4-1.7,0.1-3.5,1.2-4.8l13.2,13.2C54.4,369.9,52.7,370.3,51,370z M68.9,373.7c-0.9,0.9-2.4,0.9-3.3,0l-28.2-28.2 c-0.9-0.9-0.9-2.4,0-3.3l1.6-1.6l31.5,31.5L68.9,373.7z M74.6,371.2h5.2v5.2l0,0L74.6,371.2z M235.4,226.3L135.3,326.5V324h1.6 l-3.1-1.9v0.4h-5.2v-3.7l-1.5-0.9v4.7h-5.2v-5.2h4.3l-2.4-1.5h-1.9v-1.2l-1.5-0.9v2.1H115v-5.2h0.3l-2.4-1.5h-4.6v-2.9l-1.5-0.9v3.8 h-5.2V304h3l-2.4-1.5h-0.6V302l-1.5-0.9v1.3h-5.2v-4.6l-3.4-2.1h-3.3v-2.1l-1.5-0.9v3h-5.2v-5.2H83l-3.2-2v0.5h-5.2v-3l110.2-110.2 c1.3-1.2,3.2-1.2,4.5,0l9,9c-12.2,12.1-64.9,64.8-65.6,65.6c-7.6,9-7.5,21.1,0.1,28.7c7.9,8,20.7,8,28.7,0.1l0.1-0.1l65.5-65.5 l8.2,8.2v0.1c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.3,0.5,0.6,0.7c0.1,0.4,0.2,0.8,0.2,1.2C236.3,224.9,236.1,225.8,235.4,226.3 L235.4,226.3z M200.8,187.2l23.9,23.9l-65.5,65.5c-6.6,6.6-17.3,6.6-23.9,0c-6.3-6.3-6.3-16.4,0.1-24 C136.5,251.4,178.4,209.6,200.8,187.2z M237.9,219.3l-46.1-46.1l-0.2-0.2l27.4-67.7l86.6,86.6L237.9,219.3z M321.8,183.6l-7.5,7.5 c-1.3,1.2-3.2,1.2-4.5,0l-90.4-90.4l0,0c-1.2-1.2-1.2-3.2,0-4.4l7.5-7.5c1.2-1.2,3.2-1.2,4.4,0l90.4,90.4c0.6,0.6,0.9,1.4,0.9,2.2 C322.7,182.2,322.4,183,321.8,183.6L321.8,183.6z M19.3,221.1c0-0.5-0.3-0.9-0.8-1.1l-16.6-5.5c-0.5-0.2-1,0-1.3,0.4 c-0.3,0.4-0.4,0.9-0.1,1.3l5.4,10.2c0.2,0.4,0.6,0.6,1.1,0.6c0.2,0,0.3,0,0.5-0.1l11.2-4.7C19.1,222,19.3,221.5,19.3,221.1z  M7.4,224.3l-3.5-6.6l10.7,3.6L7.4,224.3z M127.4,78.8c0.2,0.7-0.2,1.3-0.9,1.5c0,0,0,0,0,0h-0.3c-0.5,0-1-0.4-1.2-0.9 c-0.3-1.3-1.1-1.7-2.6-2.4s-3.2-1.6-3.8-4s0.5-4.1,1.4-5.4s1.4-2.1,1.1-3.4s-1.1-1.7-2.6-2.4s-3.2-1.6-3.8-4c-0.1-0.7,0.3-1.3,1-1.4 c0.6-0.1,1.2,0.2,1.4,0.8c0.3,1.3,1.1,1.7,2.6,2.4s3.2,1.6,3.8,4s-0.5,4-1.4,5.4s-1.4,2.1-1.1,3.4s1.1,1.7,2.6,2.4 S126.8,76.4,127.4,78.8z M23.8,249.3h-0.2l-7.4-0.2c-1-0.1-1.9,0.6-2.1,1.5l-2.1,7.1v0.2c-0.2,1.1,0.5,2.1,1.6,2.3h0.2l7.4,0.2h0.2 c0.4,0,0.8-0.1,1.1-0.4c0.4-0.3,0.7-0.7,0.8-1.2l2.1-7.1v-0.1C25.6,250.5,24.9,249.5,23.8,249.3z M21,257.9l-6.5-0.2l1.9-6.3 l6.5,0.2L21,257.9z M78.3,92.4c0-0.5-0.2-0.9-0.5-1.3c-0.3-0.4-0.8-0.6-1.3-0.6l-7.3-1.2H69c-1.1,0-1.9,0.8-2,1.9v0.2l0.7,7.4 c0,0.5,0.2,0.9,0.5,1.3c0.3,0.4,0.8,0.6,1.3,0.6l7.3,1.2h0.3c0.5,0,0.9-0.2,1.3-0.5c0.4-0.4,0.6-0.9,0.6-1.4v-0.2L78.3,92.4z  M70.1,98.3l-0.6-6.5l6.4,1.1l0.6,6.5L70.1,98.3z M196.3,401.8c-0.1,0.5-0.6,0.9-1.2,0.9h-0.3l-4.5-1.1l-1.1,4.5 c-0.1,0.5-0.6,0.9-1.2,0.9h-0.3c-0.6-0.2-1-0.8-0.9-1.5l1.1-4.5l-4.5-1.1c-0.7-0.1-1.2-0.7-1.1-1.4s0.7-1.2,1.4-1.1c0,0,0.1,0,0.1,0 h0.2l4.5,1.1l1.1-4.5c0.1-0.7,0.8-1.1,1.4-1c0.7,0.1,1.1,0.8,1,1.4c0,0.1,0,0.1,0,0.2l-1.1,4.5l4.5,1.1 C196.1,400.5,196.5,401.1,196.3,401.8z M364.4,419.6c-0.1,0.6-0.6,1.1-1.2,1.1h-0.1l-4.9-0.6l-0.6,4.9c-0.1,0.6-0.6,1.1-1.2,1.1 h-0.1c-0.6-0.1-1.1-0.7-1.1-1.3l0.6-4.9l-4.9-0.6c-0.7-0.1-1.2-0.6-1.1-1.3c0.1-0.7,0.6-1.2,1.3-1.1l4.9,0.6l0.6-4.9 c0.1-0.7,0.6-1.2,1.3-1.1c0.7,0.1,1.2,0.6,1.1,1.3l0,0l0,0l-0.6,4.9l4.9,0.6c0.6,0,1.1,0.5,1.1,1.1 C364.4,419.5,364.4,419.5,364.4,419.6L364.4,419.6z M317.4,71.5c0.5,0.4,0.6,1.2,0.2,1.7c-0.2,0.3-0.6,0.4-0.9,0.4 c-0.3,0-0.6-0.1-0.8-0.3L305.4,65c-0.5-0.4-0.6-1.2-0.2-1.7s1.2-0.6,1.7-0.2L317.4,71.5z M324,51.9l-0.3,8.8c0,0.6-0.6,1.2-1.2,1.2 l0,0c-0.7,0-1.2-0.5-1.2-1.2l0.3-8.8c0-0.6,0.5-1.2,1.1-1.2c0,0,0,0,0,0h0.1c0.6-0.1,1.1,0.4,1.2,1C324,51.8,324,51.8,324,51.9 L324,51.9z M336.7,326.1c0.2,0.6-0.1,1.3-0.7,1.6c-0.1,0.1-0.3,0.1-0.4,0.1c-0.5,0-0.9-0.3-1.1-0.8l-4.6-11.5 c-0.2-0.6,0.1-1.4,0.7-1.6c0.6-0.2,1.4,0.1,1.6,0.7l0,0l0,0L336.7,326.1z M351,313.5l-4.2,6.9c-0.2,0.4-0.6,0.6-1,0.6 c-0.2,0-0.4-0.1-0.6-0.2c-0.6-0.3-0.7-1-0.4-1.6c0,0,0,0,0,0l0,0l4.2-6.9c0.3-0.6,1-0.7,1.6-0.4c0,0,0,0,0,0l0,0 C351.1,312.2,351.3,312.9,351,313.5z M341.2,155.5l11-0.5c0.7-0.1,1.2,0.4,1.3,1.1c0.1,0.7-0.4,1.2-1.1,1.3l0,0l0,0l-11,0.5h-0.1 c-0.6,0-1.1-0.5-1.2-1.1c-0.1-0.6,0.3-1.2,0.9-1.3L341.2,155.5z M342,145.3l4.1-6c0.4-0.6,1.1-0.7,1.7-0.3c0.6,0.4,0.7,1.1,0.3,1.7 l-4.1,6c-0.2,0.3-0.6,0.5-1,0.5c-0.2,0-0.5-0.1-0.7-0.2C341.8,146.6,341.6,145.9,342,145.3z M280.6,93.9L280.6,93.9 c3.3-2.4,4-7,1.6-10.3c-2.4-3.3-7-4-10.3-1.6c-3.3,2.4-4,7-1.6,10.3c1.4,1.9,3.6,3,6,3C277.9,95.3,279.4,94.8,280.6,93.9L280.6,93.9 z M272.3,90.9c-1.6-2.2-1.1-5.3,1.1-6.9c0.9-0.6,1.9-0.9,2.9-0.9c1.6,0,3.1,0.8,4,2.1c1.6,2.2,1.1,5.3-1.1,6.9l0,0 C277,93.6,273.9,93.1,272.3,90.9z M289,315.6c-1.6,1.1-2.7,2.9-3,4.8c-0.3,1.9,0.1,3.9,1.3,5.5c1.1,1.6,2.9,2.7,4.8,3 c0.4,0.1,0.8,0.1,1.2,0.1c1.5,0,3-0.5,4.3-1.4l0,0c3.3-2.4,4.1-7,1.7-10.3C296.9,314,292.3,313.2,289,315.6L289,315.6L289,315.6 L289,315.6z M296.2,325.6c-1.1,0.8-2.4,1.1-3.7,0.9c-1.3-0.2-2.5-0.9-3.2-2c-0.8-1.1-1.1-2.4-0.9-3.7c0.2-1.3,0.9-2.5,2-3.2 c0.9-0.6,1.9-0.9,2.9-0.9c1.6,0,3.1,0.8,4,2.1C298.9,321,298.4,324,296.2,325.6C296.2,325.6,296.2,325.6,296.2,325.6L296.2,325.6z  M340.3,226.5c0.2,0.4,0.1,0.9-0.2,1.3c-0.2,0.3-0.6,0.4-0.9,0.4h-0.3l-9.6-2.7c-0.6-0.2-1-0.9-0.8-1.5c0,0,0,0,0,0l0,0 c0.2-0.6,0.9-1,1.5-0.8l7.2,2.1l-1.5-3.7c-0.2-0.4-0.1-0.9,0.2-1.3c0.3-0.3,0.8-0.5,1.2-0.3l9.9,3c0.6,0.2,1,0.9,0.8,1.5 c-0.2,0.6-0.9,1-1.5,0.8l-7.5-2.2L340.3,226.5z M229.1,68.3c0.3,0.4,0.4,0.9,0.2,1.3l-3.7,9.3c-0.2,0.5-0.6,0.8-1.1,0.8 c-0.1,0-0.3,0-0.4-0.1c-0.6-0.3-0.9-1-0.7-1.6l2.8-7l-3.9,1.1c-0.4,0.1-0.9,0-1.2-0.4c-0.3-0.4-0.4-0.9-0.2-1.3l4-9.6 c0.3-0.6,1-0.8,1.6-0.5c0.5,0.3,0.8,0.9,0.6,1.5l-3,7.2l3.8-1.1C228.4,67.8,228.8,67.9,229.1,68.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "MaintenanceIcon.237384b.svg";
export { ForwardRef as ReactComponent };